import { useCallback } from 'react';
import { useAuth } from '../AuthContext';
import { rateLimiter } from './simpleRateLimiter';

export const useSimpleRateLimit = () => {
    const { user } = useAuth();

    const checkRateLimit = useCallback(() => {
        if (!user) return true;
        return rateLimiter.canMakeRequest(user.uid);
    }, [user]);

    const getRemainingRequests = useCallback(() => {
        if (!user) return 0;
        return rateLimiter.getRemainingRequests(user.uid);
    }, [user]);

    return {
        checkRateLimit,
        getRemainingRequests
    };
};